interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohort: string;
	statsigAAExperiment?: string;
}

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		messageTemplateId: 'confluence-nudge-for-jira',
		statsigExperiment: 'post-office_expt_confluence-nudge-for-jira',
		statsigAAExperiment: 'post-office_expt_confluence-nudge-for-jira_aa',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
	{
		messageTemplateId: 'confluence-3p-connector-nudge',
		statsigExperiment: 'post-office_3p_user_authentication_nudge',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
	{
		messageTemplateId: 'confluence-auto-provisioning-edition-parity-trial-dialog',
		// https://switcheroo.atlassian.com/ui/gates/d0ba1046-934a-4af7-8294-e6ca8b846ab3/key/confluence_autoprovisioning_edition_parity
		statsigExperiment: 'confluence_autoprovisioning_edition_parity',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
];
